
export const SPRITE_PATHS = {
  "default": "/_nuxt/nuxt-svg/sprite-default.E5vndxoEWDaq9CBU5eN2SAIbx2yskxnkr7Cgf8vYO5Q.svg"
}
export const runtimeOptions = {"ariaHidden":false}
